
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Flame } from 'lucide-react';

const GasQuality = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={700}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Gas Quality</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="flex flex-col items-center justify-center">
          <Flame className="h-12 w-12 text-amber-600 mb-4" />
          <p className="text-3xl font-bold text-amber-600">97.2%</p>
          <p className="text-sm text-green-600 mt-2">↑ 0.2% from last month</p>
          <p className="text-xs text-gray-500 mt-4 text-center">
            Gas quality score based on methane content and purity tests
          </p>
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasQuality;
